//deps
import styled from "styled-components";

// internal deps
import { Tooltip, AriaHidden } from "@swiggy-private/core-ui";

// dls components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

interface IProps {
    isTurboWidget: boolean;
}

export const TooltipContainer = styled(AriaHidden)<IProps>(({ theme, isTurboWidget }) => ({
    position: "absolute",
    ...(isTurboWidget && {
        right: theme.spacing.medium,
        bottom: 148,
    }),
    ...(!isTurboWidget && {
        left: theme.spacing.xSmall,
        top: -52,
    }),
}));

export const TooltipIcon = styled.div(({ theme }) => ({
    marginRight: theme.spacing.xSmall,
}));

export const StyledTooltip = styled(Tooltip)<IProps>`
    width: 300px;
    z-index: 1;

    &:before {
        left: ${props => (props.isTurboWidget ? "inherit" : "21px")};
        right: ${props => (props.isTurboWidget ? "24px" : "inherit")};
    }
`;

export const TooltipText = styled(Text)({
    marginTop: -2,
});
